module.exports = __webpack_public_path__ + "img/scratchDescription.a0e06ae4.png";